import { AxiosResponse } from 'axios'
import { User } from '../interfaces/User.interface'

import { employeesApi } from './'

export const authenticate = (googleToken: string) => (
  employeesApi.get('/auth/google', {
    params: {
      id_token: googleToken,
    },
  })
    .then((response: AxiosResponse) => response.data)
)

export const getCurrentUser = () => (
  employeesApi.get<User>('/user')
    .then((response: AxiosResponse) => response.data)
)



// WEBPACK FOOTER //
// ./src/lib/api/auth.ts